import React from 'react';

export default function QuestionIcon() {
	return (
		<svg
			width='29'
			height='29'
			viewBox='0 0 29 29'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M14.5 18.8828C15.3496 18.8828 16.0859 19.6191 16.0859 20.4688C16.0859 21.375 15.3496 22.0547 14.5 22.0547C13.5938 22.0547 12.9141 21.375 12.9141 20.4688C12.9141 19.6191 13.5938 18.8828 14.5 18.8828ZM14.8965 17.5234H13.9902C13.6504 17.5234 13.3105 17.2402 13.3105 16.8438C13.3105 12.8789 17.7285 13.2188 17.7285 10.7832C17.7285 9.65039 16.709 8.46094 14.4434 8.46094C12.8008 8.46094 11.9512 9.02734 11.1016 10.1035C10.875 10.3867 10.4785 10.4434 10.1953 10.2734L9.45898 9.70703C9.11914 9.48047 9.0625 9.08398 9.28906 8.74414C10.4785 7.21484 11.8945 6.19531 14.4434 6.19531C17.3887 6.19531 19.9941 7.89453 19.9941 10.7832C19.9941 14.5781 15.5762 14.4082 15.5762 16.8438C15.5762 17.2402 15.293 17.5234 14.8965 17.5234ZM14.5 1.89062C7.70312 1.89062 2.26562 7.38477 2.26562 14.125C2.26562 20.9219 7.70312 26.3594 14.5 26.3594C21.2402 26.3594 26.7344 20.9219 26.7344 14.125C26.7344 7.38477 21.1836 1.89062 14.5 1.89062ZM14.5 0.078125C22.2031 0.078125 28.5469 6.42188 28.5469 14.125C28.5469 21.8848 22.2031 28.1719 14.5 28.1719C6.74023 28.1719 0.453125 21.8848 0.453125 14.125C0.453125 6.42188 6.74023 0.078125 14.5 0.078125Z'
				fill='#575757'
			/>
		</svg>
	);
}
